import * as React from 'react';

export interface ILocationSectionHeaderProps extends React.PropsWithChildren {}

export const LocationSectionHeader: React.FunctionComponent<
  ILocationSectionHeaderProps
> = props => {
  return (
    <div className='col-span-6 mb-5 pr-5 font-semibold text-muted-foreground md:col-span-2 md:mb-0'>
      {props.children}
    </div>
  );
};
